<template>
  <button
    type="submit"
    :disabled="disabled"
    :class="`${color} py-1.5 px-4 rounded disabled:opacity-75`"
  >
    <div class="flex">
      <template v-if="disabled">
        <base-svg-icon class="w-6 animate-spin mr-1 p-0.5" :path="mdiLoading" />
      </template>
      <div class="whitespace-nowrap">
        {{ text }}
      </div>
    </div>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiLoading } from '@mdi/js'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    disabled: {
      type: Boolean,
      'default': () => (false),
    },
    text: {
      type: String,
      'default': () => (useI18n().t('word.send')),
    },
    color: {
      type: String,
      'default': () => ('bg-blue-500 hover:bg-blue-400 text-white'),
    },
  },
  setup() {
    return {
      mdiLoading,
    }
  },
})
</script>
